<div mat-dialog-content>
    <app-user-search (userSelected)="onUserSelected($event)" [roleInput]="roleInput"></app-user-search>
</div>